export default (paymentid, store) => {
  let execLoop = setInterval(() => {
    store.dispatch('GetPayment', paymentid)
      .then(payment => {
        if(payment.status === 'aprovado') {
          store.dispatch('_UpdatePedidoPaymentid', paymentid)
          store.dispatch('setPixPaymentStatus', true)
          clearInterval(execLoop)
        }
      })
  }, 5000);
}
